import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");
    if (!session_id) { navigate("/admin/login", { replace: true }); return; }
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        window.history.replaceState({}, "", "/admin");
        if (r.data?.is_admin) {
          navigate("/admin", { replace: true, state: { user: r.data.user } });
        } else {
          toast.error("This Google account is not authorized for admin.");
          navigate("/", { replace: true });
        }
      } catch (e) {
        toast.error("Sign-in failed");
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [location.hash, navigate]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center text-slate-400">Signing you in…</div>
  );
}
